<div class="c-card">
    <div class="c-card__header">
        <div class="c-card__ribbon">
            <div class="c-card__item c-card__item--left mb-2">
                <h3>{{ title() }}</h3>
                <span class="required-asterisk" [class.hidden]="!showTitleAsteriskWhenEditMode() || mode() !== 'edit'"
                    >*</span
                >
            </div>

            @if (!isLoading()) {
                <div class="flex flex-row gap-medpace">
                    <ng-content select="card-header-additional-content"></ng-content>
                    @if (showEditSaveButton()) {
                        <!-- add '!' before 'hidden' to make it '!important'. MDS v8 applies a css rule:
                          mds-button & mds-button { display: inline-flex } (_button.scss:21),
                           which overrides our rule to hide the button when mode is 'edit' or 'view'.
                           -->
                        @if (showCancelButton()) {
                            <mds-button
                                [class.!hidden]="mode() === 'view'"
                                (clickEvent)="tryChangeMode('view', true)"
                                [label]="'Cancel'"
                                [variant]="'text'"
                                [color]="'primary'"
                                [id]="'cancelBtn'"
                            ></mds-button>
                        }
                        <mds-button
                            [class.!hidden]="mode() === 'edit'"
                            (clickEvent)="tryChangeMode('edit')"
                            [label]="'Edit'"
                            [variant]="'tonal'"
                            [color]="'primary'"
                            [id]="'editBtn'"
                        ></mds-button>
                        <mds-button
                            [class.!hidden]="mode() === 'view'"
                            (clickEvent)="tryChangeMode('view')"
                            [label]="'Save'"
                            [variant]="'tonal'"
                            [color]="'primary'"
                            [id]="'saveBtn'"
                        ></mds-button>
                    }
                </div>
            }
        </div>
    </div>
    <div class="c-card__content" [class.hidden]="isLoading()">
        @if (showSharedContent()) {
            <ng-content select="card-shared-content"></ng-content>
        }
        <div [class.hidden]="mode() === 'view'">
            <ng-content select="card-edit-mode-content"></ng-content>
        </div>

        <div [class.hidden]="mode() === 'edit'">
            <ng-content select="card-view-mode-content"></ng-content>
        </div>
    </div>

    <div class="c-card__content" [class.hidden]="!isLoading()">
        <!-- TODO: maybe skeleton load? -->
        <medpace-loading-card />
    </div>
</div>
